export const FETCH_VIOLATE_REASONS = {
    REQUEST: 'FETCH_VIOLATE_REASONS_REQUEST',
    SUCCESS: 'FETCH_VIOLATE_REASONS_SUCCESS',
    FAILED: 'FETCH_VIOLATE_REASONS_FAILED',
};
